/* eslint-disable @typescript-eslint/no-explicit-any */
import { ajax, AjaxResponse, AjaxError } from 'rxjs/ajax';
import { Observable, throwError } from 'rxjs';
import { API_BASE_URL } from 'constants/endpoints';
import { map, catchError } from 'rxjs/operators';
import { getMinorToMajorToken, getUserToken, removeUserDetails } from './storage';
import loader from './loader-util';
import elementVisibilty from './toggleVisibilty-util';

export const getFormDataFromJson = (data: any): FormData => {
	const formData = new FormData();
	if (data) {
		Object.keys(data).forEach((key) => {
			formData.append(key, data[key]);
		});
	}
	return formData;
}

export const getDefaultHeadersWOContentType: any = () => {
	let defHeaders = {};
	let token = getUserToken();
	if (token) {
		defHeaders = Object.assign({}, defHeaders, { 'X-Auth-Token': token })
	}
	return defHeaders;
};

export const getDefaultHeaders = (isUserBlocked?:boolean) => {
	let defHeaders = {
		'Content-Type': 'application/json'
	};
	let token = isUserBlocked ? getMinorToMajorToken() : getUserToken();
	if (token) {
		defHeaders = Object.assign({}, defHeaders, { 'X-Auth-Token': token })
	}
	return defHeaders;
};

const handleAPISuccess = (response: AjaxResponse): AjaxResponse => {
	loader.hide();
	return response;
}

const handleAPIError = (error: any) => {
	loader.hide();
	if (error && error.status === 401) {
		removeUserDetails();
		elementVisibilty.show('loginDiv');
	}
	return throwError(error);
}

export const get = (url: string, headers?: any, showLoader?: boolean): Observable<AjaxResponse | AjaxError> => {
	if (showLoader) loader.show();
	return ajax({
		url: API_BASE_URL + url,
		method: 'GET',
		withCredentials: true,
		headers: Object.assign({}, getDefaultHeaders(), headers)
	}).pipe(
		map((response: AjaxResponse): AjaxResponse => handleAPISuccess(response)),
		catchError((error: any) => handleAPIError(error))
	);
};

export const getForMinorToken = (url: string, headers?: any, showLoader?: boolean): Observable<AjaxResponse | AjaxError> => {
	const majorStatus = sessionStorage.getItem('majorStatus') || '';

	if (showLoader) loader.show();
	return ajax({
		url: API_BASE_URL + url,
		method: 'GET',
		withCredentials: true,
		headers: Object.assign({}, getDefaultHeaders(majorStatus ? true : false), headers)
	}).pipe(
		map((response: AjaxResponse): AjaxResponse => handleAPISuccess(response)),
		catchError((error: any) => handleAPIError(error))
	);
};

export const post = (url: string, body: any, headers?: any, showLoader?: boolean) => {
	if (showLoader) loader.show();
	return ajax({
		url: API_BASE_URL + url,
		method: "POST",
		body,
		withCredentials: true,
		headers: Object.assign({}, getDefaultHeaders(), headers)
	}).pipe(
		map((response: AjaxResponse): AjaxResponse => handleAPISuccess(response)),
		catchError((error: any) => handleAPIError(error))
	);
}

// Use when need to send form data. It cannot be sent with RxJs ajax

export const fetchPost = (url: string, body: any, headers?: any, showLoader?: boolean): Promise<Response> => {
	if (showLoader) loader.show();
	return fetch(
		API_BASE_URL + url,
		{
			method: "POST",
			headers: Object.assign({}, getDefaultHeadersWOContentType(), headers),
			body: body,
		})
		.then((response) => {
			if (showLoader) {
				loader.hide();
			}
			return response.json()
		})
		.catch((error: any) => {
			if (showLoader) {
				loader.hide();
			}
			// add check for token
			return error;
		});
}

export const put = (url: string, body: any, headers?: any, showLoader?: boolean) => {
	if (showLoader) loader.show();
	return ajax({
		url: API_BASE_URL + url,
		method: 'PUT',
		body,
		withCredentials: true,
		headers: Object.assign({}, getDefaultHeaders(), headers)
	}).pipe(
		map((response: AjaxResponse): AjaxResponse => handleAPISuccess(response)),
		catchError((error: any) => handleAPIError(error))
	);
}

export const deleteRequest = (url: string, body: any, headers?: any, showLoader?: boolean) => {
	if (showLoader) loader.show();
	return ajax({
		url: API_BASE_URL + url,
		method: 'DELETE',
		body,
		withCredentials: true,
		headers: Object.assign({}, getDefaultHeaders(), headers)
	}).pipe(
		map((response: AjaxResponse): AjaxResponse => handleAPISuccess(response)),
		catchError((error: any) => handleAPIError(error))
	);
}
